<template>
  <div v-if="cancellations.length" class="cancel-history">
    <div class="text-subtitle-2 font-weight-bold mb-2">
      <v-icon small color="error" left>fal fa-history</v-icon>
      {{ $t(hasAdds ? "bill_edit_history" : "cancelled_items_history") }}
    </div>
    <div
      v-for="entry in cancellations"
      :key="entry.id"
      class="cancel-history__entry px-3 py-2"
    >
      <div class="d-flex align-center flex-wrap mb-1">
        <v-icon x-small left :color="look(entry).color">
          {{ look(entry).icon }}
        </v-icon>
        <span class="text-body-2">
          {{ $t(look(entry).by) }}:
          <span class="font-weight-bold">{{ entry.user_name || "-" }}</span>
        </span>
        <v-spacer />
        <span class="text-caption text--secondary">
          <v-icon x-small left>fal fa-clock</v-icon>
          {{ entry.created_at | formatDateTime }}
        </span>
        <v-chip
          v-if="entry.stage === 'before_checkout'"
          x-small
          outlined
          class="ml-2"
        >
          {{ $t("cancelled_before_checkout") }}
        </v-chip>
        <v-chip
          v-if="entry.whole_bill"
          x-small
          outlined
          color="error"
          class="ml-2"
        >
          {{ $t("whole_bill_cancelled") }}
        </v-chip>
      </div>
      <div
        v-for="(item, index) in entry.items"
        :key="`${entry.id}-${index}`"
        class="d-flex justify-space-between text-body-2"
      >
        <span>{{ item.name || "-" }} × {{ item.qty }}</span>
        <span :class="`${look(entry).color}--text`">
          {{ look(entry).sign }}{{ item.amount | NumberFormat }}
        </span>
      </div>
      <div v-if="!entry.items.length" class="text-body-2">
        {{ $t("cancel_whole_bill") }}
      </div>
      <!-- Items are at their sold price; the bill total also moves by the
           discount and VAT that went with them. -->
      <div
        class="d-flex justify-space-between text-body-2 font-weight-bold mt-1"
      >
        <span>{{ $t(look(entry).totalLabel) }}</span>
        <span :class="`${look(entry).color}--text`">
          {{ look(entry).sign }}{{ entry.amount | NumberFormat }}
        </span>
      </div>
      <div v-if="entry.reason" class="text-caption text--secondary">
        {{ $t("noted") }}: {{ entry.reason }}
      </div>
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/mixin/main";

/**
 * What was cancelled off a bill, one entry per cancel (QRIPO-543): when, by
 * whom, why and which items. Fed by the `cancellations` that bill_detail
 * returns.
 */
export default {
  name: "CancelHistory",
  mixins: [myMixin],
  props: {
    cancellations: { type: Array, default: () => [] },
  },
  computed: {
    hasAdds() {
      return this.cancellations.some((entry) => entry.action === "add");
    },
  },
  methods: {
    // Items added to the bill read as "+", in blue; cancels as "-", in red.
    look(entry) {
      return entry.action === "add"
        ? {
            color: "info",
            icon: "fal fa-plus",
            by: "added_by",
            totalLabel: "add_total_with_vat",
            sign: "+",
          }
        : {
            color: "error",
            icon: "fal fa-user",
            by: "cancelled_by",
            totalLabel: "cancel_total_with_vat",
            sign: "-",
          };
    },
  },
  filters: {
    formatDateTime(value) {
      if (!value) return "";
      const date = new Date(String(value).replace(" ", "T"));
      if (Number.isNaN(date.getTime())) return value;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(date.getDate())}/${pad(
        date.getMonth() + 1
      )}/${date.getFullYear()} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`;
    },
  },
};
</script>

<style scoped>
.cancel-history__entry {
  border: 1px solid var(--app-border, #e0e0e0);
  border-radius: 8px;
}

.cancel-history__entry + .cancel-history__entry {
  margin-top: 8px;
}
</style>
